import { DEFAULT_CONTENTS, EMPTY_ARRAY } from '~~/shared-components/content/const'

export const FormkitLookupOptions = {
  props: {
    tab: {
      default: undefined,
    },
    url: {
      default: undefined,
    },
    dataKey: {
      default: 'value',
    },
    apiFilter: {
      default: undefined,
    },
    query: {
      default: undefined,
    },
    optionDisabled: {
      default: null,
    },
    optionLabel: {
      default: 'name',
    },
    optionValue: {
      default: null,
    },
    filterByTerm: {
      boolean: true,
      default: false,
    },
    valueLink: {
      default: undefined,
    },
    addNew: {
      default: undefined,
    },
    addNewUrl: {
      default: undefined,
    },
    edit: {
      boolean: true,
      default: false,
    },
    editUrl: {
      default: undefined,
    },
    addNewObject: {
      default: undefined,
    },
    withConfirm: {
      boolean: true,
      default: false,
    },
    chips: {
      boolean: true,
      default: false,
    },
    multiple: {
      boolean: true,
      default: false,
    },
    withImage: {
      boolean: true,
      default: false,
    },
    imageSrc: {
      default: undefined,
    },
    disabledLocalSearch: {
      boolean: true,
      default: true,
    },
    filterMode: {
      boolean: true,
      default: false,
    },
    filterKey: {
      default: undefined,
    },
  },
}

export const FormkitDropdownOptions = {
  props: {
    tab: {
      default: undefined,
    },
    filter: {
      boolean: true,
      default: false,
    },
    showClear: {
      boolean: true,
      default: false,
    },
    optionValue: {
      default: 'value',
    },
    options: {
      default: EMPTY_ARRAY,
    },
    placeholder: {
      default: null,
    },
    optionLabel: {
      default: 'name',
    },
    valueLabel: {
      default: undefined,
    },
    optionDisabled: {
      default: undefined,
    },
    optionGroupLabel: {
      default: undefined,
    },
    optionGroupChildren: {
      default: undefined,
    },
    address: {
      boolean: true,
      default: false,
    },
    readonly: {
      boolean: true,
      default: false,
    },
    languageDependent: { boolean: true, default: false },
  },
}
export const FormkitCheckboxOptions = {
  props: {
    tab: {
      default: undefined,
    },
    title: { default: undefined },
    capitalize: {
      boolean: true,
      default: false,
    },
    languageDependent: { boolean: true, default: false },
  },
}
export const FormkitAutocompleteOptions = {
  props: {
    options: { default: EMPTY_ARRAY },
    dataKey: { default: 'value' },
    optionName: { default: 'name' },
    optionValue: { default: 'value' },
    dropdown: {
      boolean: true,
      default: true,
    },
    languageDependent: { boolean: true, default: false },
  },
}
export const FormkitRadioOptions = {
  props: {
    tab: {
      default: undefined,
    },
    options: {
      default: undefined,
    },
    vertical: {
      boolean: true,
      default: false,
    },
    optionName: {
      default: 'name',
    },
    optionValue: {
      default: 'value',
    },
    languageDependent: { boolean: true, default: false },
  },
}

export const FormkitNumberOptions = {
  props: {
    tab: {
      default: undefined,
    },
    icon: {
      default: undefined,
    },
    leftAddon: {
      default: undefined,
    },
    rightAddon: {
      default: undefined,
    },
    addonWidth: {
      default: 'auto',
    },
    min: {
      default: undefined,
    },
    max: {
      default: undefined,
    },
    currency: {
      default: undefined,
    },
    minFractionDigits: {
      default: undefined,
    },
    maxFractionDigits: {
      default: undefined,
    },
    showButtons: {
      boolean: true,
      default: false,
    },
    buttonLayout: {
      default: undefined,
    },
    step: {
      default: undefined,
    },
    decrementButtonClass: {
      default: undefined,
    },
    incrementButtonClass: {
      default: undefined,
    },
    placeholder: {
      default: undefined,
    },
    readonly: {
      boolean: true,
      default: false,
    },
    fluid: {
      boolean: true,
      default: false,
    },
    useGrouping: {
      boolean: true,
      default: true,
    },
    languageDependent: { boolean: true, default: false },
  },
}
export const FormkitInputOptions = {
  props: {
    tab: {
      default: undefined,
    },
    rightButton: {
      default: undefined,
    },
    rightIcon: {
      default: undefined,
    },
    rightAddon: {
      default: undefined,
    },
    leftAddon: {
      default: undefined,
    },
    autoFocus: {
      boolean: true,
      default: false,
    },
    disabledRightButton: {
      boolean: true,
      default: false,
    },
    disabledRightIcon: {
      boolean: true,
      default: false,
    },
    icon: {
      default: undefined,
    },
    inputType: {
      default: undefined,
    },
    placeholder: {
      default: undefined,
    },
    checkDuplicate: {
      boolean: true,
      default: false,
    },
    duplicateUrl: {
      default: undefined,
    },
    duplicateLink: {
      default: undefined,
    },
    duplicateValidation: {
      boolean: true,
      default: false,
    },
    rightIconParams: {
      default: undefined,
    },
    address: {
      boolean: true,
      default: false,
    },
    languageDependent: { boolean: true, default: false },
  },
}

export const FormkitPhoneOptions = {
  props: {
    tab: {
      default: undefined,
    },
    icon: {
      default: undefined,
    },
    leftAddon: {
      default: undefined,
    },
    rightAddon: {
      default: undefined,
    },
    addonWidth: {
      default: 'auto',
    },
    min: {
      default: undefined,
    },
    max: {
      default: undefined,
    },
    currency: {
      default: undefined,
    },
    minFractionDigits: {
      default: undefined,
    },
    maxFractionDigits: {
      default: undefined,
    },
    showButtons: {
      boolean: true,
      default: false,
    },
    buttonLayout: {
      default: undefined,
    },
    step: {
      default: undefined,
    },
    decrementButtonClass: {
      default: undefined,
    },
    incrementButtonClass: {
      default: undefined,
    },
    placeholder: {
      default: undefined,
    },
    languageDependent: { boolean: true, default: false },
  },
}

export const FormkitTextAreaOptions = {
  props: {
    tab: {
      default: undefined,
    },
    placeholder: {
      default: undefined,
    },
    languageDependent: { boolean: true, default: false },
  },
}

export const FormkitChipsOptions = {
  props: {
    tab: {
      default: undefined,
    },
    icon: {
      default: undefined,
    },
    separator: {
      default: undefined,
    },
    languageDependent: { boolean: true, default: false },
    validateValue: {
      default: () => true,
    },
  },
}

export const FormkitSelectButtonOptions = {
  props: {
    tab: {
      default: undefined,
    },
    optionValue: {
      default: 'value',
    },
    optionLabel: {
      default: 'name',
    },
    multiple: {
      boolean: true,
      default: false,
    },
    options: {
      default: EMPTY_ARRAY,
    },
    languageDependent: { boolean: true, default: false },
  },
}

export const FormkitCalendarOptions = {
  props: {
    tab: {
      default: undefined,
    },
    minDate: {
      default: undefined,
    },
    maxDate: {
      default: undefined,
    },
    showTime: {
      boolean: true,
      default: false,
    },
    showSeconds: {
      boolean: true,
      default: false,
    },
    timeOnly: {
      boolean: true,
      default: false,
    },
    monthOnly: {
      boolean: true,
      default: false,
    },
    yearOnly: {
      boolean: true,
      default: false,
    },
    showClear: {
      boolean: true,
      default: true,
    },
    placeholderDate: {
      default: undefined,
    },
    openOnFocus: {
      boolean: true,
      default: true,
    },
    languageDependent: { boolean: true, default: false },
  },
}

export const FormkitSwitchOptions = {
  props: {
    tab: {
      default: undefined,
    },
    trueValue: {
      default: undefined,
    },
    falseValue: {
      default: undefined,
    },
    sample: {
      default: false,
      boolean: true,
    },
    languageDependent: { boolean: true, default: false },
  },
}

export const FormkitCheckboxGroupOptions = {
  props: {
    tab: {
      default: undefined,
    },
    options: {
      default: EMPTY_ARRAY,
    },
    itemKey: {
      default: undefined,
    },
    capitalize: {
      boolean: true,
      default: false,
    },
    optionLabel: {
      default: undefined,
    },
    languageDependent: { boolean: true, default: false },
  },
}

export const FormkitMultiSelectOptions = {
  props: {
    tab: {
      default: undefined,
    },
    optionLabel: {
      default: 'name',
    },
    optionValue: {
      default: 'value',
    },
    options: {
      default: EMPTY_ARRAY,
    },
    languageDependent: { boolean: true, default: false },
  },
}

export const FormkitToggleButtonOptions = {
  props: {
    tab: {
      default: undefined,
    },
    languageDependent: { boolean: true, default: false },
  },
}

export const FormkitIbanOptions = {
  props: {
    tab: {
      default: undefined,
    },
    icon: {
      default: undefined,
    },
    inputType: {
      default: undefined,
    },
    rightButton: {
      default: undefined,
    },
    languageDependent: { boolean: true, default: false },
  },
}

export const FormkitBicOptions = {
  props: {
    tab: {
      default: undefined,
    },
    icon: {
      default: undefined,
    },
    inputType: {
      default: undefined,
    },
    rightButton: {
      default: undefined,
    },
    languageDependent: { boolean: true, default: false },
  },
}

export const FormkitUrlOptions = {
  props: {
    tab: {
      default: undefined,
    },
    icon: {
      default: undefined,
    },
    leftAddon: {
      default: undefined,
    },
    rightAddon: {
      default: undefined,
    },
    rightButton: {
      default: undefined,
    },
    disabledRightButton: {
      boolean: true,
      default: false,
    },
    languageDependent: { boolean: true, default: false },
  },
}

export const FormkitColorOptions = {
  props: {
    tab: {
      default: undefined,
    },
    languageDependent: { boolean: true, default: false },
  },
}
export const FormkitIconPickerOptions = {
  props: {
    tab: {
      default: undefined,
    },
    languageDependent: { boolean: true, default: false },
  },
}
export const FormkitPasswordOptions = {
  type: 'password',
  props: {
    tab: {
      default: undefined,
    },
    icon: {
      default: undefined,
    },
    placeholder: {
      default: undefined,
    },
    feedback: {
      boolean: true,
      default: false,
    },
    toggleMask: {
      boolean: true,
      default: false,
    },
    languageDependent: { boolean: true, default: false },
  },
}
export const FormkitEditorOptions = {
  props: {
    tab: {
      default: undefined,
    },
    languageDependent: { boolean: true, default: false },
  },
}
export const FormkitUploaderOptions = {
  props: {
    tab: {
      default: undefined,
    },
    replace: {
      boolean: true,
      default: false,
    },
    uploadType: {
      default: 'singleFile',
    },
    uploadCallback: {
      default: undefined,
    },
    fileType: {
      default: undefined,
    },
    accept: {
      default: undefined,
    },
    selectFilter: {
      default: undefined,
    },
    selectLabel: {
      default: undefined,
    },
    cancelConfirm: {
      default: undefined,
    },
    languageDependent: { boolean: true, default: false },
  },
}
export const FormkitPickListOptions = {
  props: {
    tab: {
      default: undefined,
    },
    options: {
      default: undefined,
    },
    showSourceControls: {
      boolean: true,
      default: true,
    },
    showTargetControls: {
      boolean: true,
      default: true,
    },
    languageDependent: { boolean: true, default: false },
    moveToTargetTooltip: {
      default: undefined,
    },
    moveToSourceTooltip: {
      default: undefined,
    },
    moveAllToSourceTooltip: {
      default: undefined,
    },
    moveAllToTargetTooltip: {
      default: undefined,
    },
  },
}
export const FormkitCodeOptions = {
  props: {
    tab: {
      default: undefined,
    },
    lang: {
      default: 'html',
    },
    languageDependent: { boolean: true, default: false },
  },
}
export const FormkitMapOptions = {
  props: {
    latitudePath: { default: undefined },
    longitudePath: { default: undefined },
    preview: {
      boolean: true,
      default: false,
    },
    languageDependent: { boolean: true, default: false },
  },
}
export const FormkitRecaptchaOptions = {
  props: {},
}

export const FormkitContentOptions = {
  props: {
    contentId: {
      default: undefined,
    },
    slotName: {
      default: undefined,
    },
    contentType: {
      default: undefined,
    },
    contentTypes: {
      default: () => ({}),
    },
    galleries: {
      default: () => [],
    },
    contentLayout: {
      default: undefined,
    },
    new: {
      boolean: true,
      default: false,
    },
    loading: {
      boolean: true,
      default: false,
    },
    showClick: {
      boolean: true,
      default: false,
    },
    contents: {
      default: DEFAULT_CONTENTS(),
    },
    inLocales: {
      default: () => [],
    },
    languageDependent: { boolean: true, default: false },
  },
}
